__turbopack_context__.v({
  "airtimeCard": "target-cards-module-scss-module__CgbK3W__airtimeCard",
  "cardBodyRow": "target-cards-module-scss-module__CgbK3W__cardBodyRow",
  "cardWrap": "target-cards-module-scss-module__CgbK3W__cardWrap",
  "pulse": "target-cards-module-scss-module__CgbK3W__pulse",
  "row": "target-cards-module-scss-module__CgbK3W__row",
  "rowItem": "target-cards-module-scss-module__CgbK3W__rowItem",
  "rowSidebar": "target-cards-module-scss-module__CgbK3W__rowSidebar",
  "sovCard": "target-cards-module-scss-module__CgbK3W__sovCard",
  "targetCardBody": "target-cards-module-scss-module__CgbK3W__targetCardBody",
  "value": "target-cards-module-scss-module__CgbK3W__value",
  "valueNoData": "target-cards-module-scss-module__CgbK3W__valueNoData" + " " + "target-cards-module-scss-module__CgbK3W__value",
  "valueSkeletonNarrow": "target-cards-module-scss-module__CgbK3W__valueSkeletonNarrow" + " " + "target-cards-module-scss-module__CgbK3W__valueSkeletonWide",
  "valueSkeletonWide": "target-cards-module-scss-module__CgbK3W__valueSkeletonWide",
});
